import { ChangeDetectionStrategy, Component } from '@angular/core';
import { VideoLayout1Component } from '@components/video/components/video-layout-1';
import { VideoLayout2Component } from '@components/video/components/video-layout-2';
import { VideoLayout } from '@components/video/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-video',
  imports: [VideoLayout1Component, VideoLayout2Component],
  templateUrl: './video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoComponent extends ComponentLoaderAbstract<Layout<VideoLayout>> {
  readonly layout = VideoLayout;
}
